import { focusStyles } from '../../../../common/focus'

let init = false

export function updateFocusStyles(shadowRoot) {
  if (init) return
  const style = document.createElement('style')
  style.innerHTML = focusStyles('#bv_review_maincontainer')
  shadowRoot.insertBefore(style, shadowRoot.firstChild)
  init = true
}
